import {useCallback, useContext, useMemo} from "react";
import {PlayerContext} from "../../../../shared/contexts/playerContext";
import {Datatable} from "../../../../shared/components/datatable/Datatable";

const Inventory = () => {
    const {playerData} = useContext(PlayerContext);

    const columnData = useCallback(() => {
        const wallet = playerData.playerInfo.walletData;
        const keys = Object.keys(wallet);

        return keys
            .filter(key => !isNaN(wallet[key]))
            .map(key => ({
                name: key,
                quantity: wallet[key]
            }));
    }, [playerData.playerInfo.walletData]);


    const columns = useMemo(() => ([
        {
            title: '아이템 이름',
            dataIndex: 'name',
        },
        {
            title: '수량',
            dataIndex: 'quantity',
        },
    ]), []);

    return (
        <div className={"player-inventory"}>
            <Datatable columns={columns} rows={columnData()}/>
        </div>
    );
};

export default Inventory;